import { Paper, Stack, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { ChangeSubscriptionBanner } from './ChangeSubscriptionBanner';

export const BannersBlock = () => {
    return (
        <Paper variant="outlined">
            <Stack gap={4} p={3}>
                <Typography variant="h2">
                    {trans('credits-store-banners-title', {}, 'student-store')}
                </Typography>
                <ChangeSubscriptionBanner />
            </Stack>
        </Paper>
    );
};
